<div class="container-fluid blotter_top_interaction_bar" #topMenu>
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar_container">
      <div
        class="bfx-blotter-filter-bar blotter_filter_bar"
        [blotterInstance]="blotterInstance"
      ></div>
    </div>
    <div class="blotter_titlebar_interaction_right">
      <div class="bfx-blotter-tools-container">
        <bfx-quick-search
          class="bfx-quick-search"
          [(ngModel)]="searchValue"
          (ngModelChange)="onChangeSearchValue()"
        ></bfx-quick-search>
        <bfx-icon-button
          size="sm"
          iconClass="icon_ion_filter_filled"
          (action)="showFilterManager($event)"
          title="Filter Manager"
        ></bfx-icon-button>
        <bfx-icon-button
          size="sm"
          iconClass="icon_ion_settings_filled"
          (action)="settingsMenu.toggle($event)"
          title="Settings"
        ></bfx-icon-button>
        <bfx-blotter-settings-menu #settingsMenu></bfx-blotter-settings-menu>
      </div>
    </div>
  </div>
</div>

<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    enableSorting
    rowHeight="22"
    (contextmenu)="handleClick($event)"
    [frameworkComponents]="frameworkComponents"
    multiSortKey="ctrl"
    (mousewheel)="onMouseWheel($event)"
    (mousedown)="onMouseDown($event)"
    (mouseup)="onMouseUp($event)"
    (keydown)="onKeyPress($event)"
    [ngClass]="{'fullTempStyled': isFullTempStyle===true}"
    [class._bfx_flash]="flashRow"
  >
  </ag-grid-angular>
</div>

<div *ngIf="windowUndocked" class="footer">
  <div class="message" fxLayout="row" [innerHTML]="vwapFooterText"></div>
</div>

<bfx-blotter-inbox-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-inbox-context-menu>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
